import PropTypes from "prop-types";

const BUYER_TYPE_LABELS = {
  vivir: "Vivir",
  invertir: "Invertir",
  "tengo cliente": "Tengo cliente",
};

export default function ContactPreferences({ additionalData = null }) {
  const buyerTypeLabel = BUYER_TYPE_LABELS[additionalData?.buyer_type] || "No disponible";
  const visitInterestLabel =
    typeof additionalData?.visit_interest === "boolean"
      ? additionalData.visit_interest
        ? "Sí"
        : "No"
      : "No disponible";

  return (
    <section
      className="mt-4 w-full border-t border-gray-200 pt-4"
      aria-labelledby="preferences-title"
    >
      <h4 id="preferences-title" className="font-semibold text-gray-900">
        Preferencias
      </h4>
      <dl className="mt-2 grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-2 text-sm">
        <dt className="font-medium text-gray-700">Me interesa para:</dt>
        <dd className="text-right text-gray-900">{buyerTypeLabel}</dd>
        <dt className="font-medium text-gray-700">Interés en visitar:</dt>
        <dd className="text-right text-gray-900">{visitInterestLabel}</dd>
      </dl>
    </section>
  );
}

ContactPreferences.propTypes = {
  additionalData: PropTypes.shape({
    buyer_type: PropTypes.oneOf(["vivir", "invertir", "tengo cliente"]),
    visit_interest: PropTypes.bool,
  }),
};
